import React from "react";
import "./SacredBasket.css";
import { Trash2 } from "lucide-react";
import GoldenButton from "../Components/GoldenButton/GoldenButton";
import { useCart } from "../Context/CartContext";
import { useNavigate } from "react-router-dom";

const SacredBasket = () => {
  const { cart, increaseQty, decreaseQty, removeItem } = useCart();
  const navigate = useNavigate();

  const cartItems = Object.values(cart);

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const gst = Math.round(subtotal * 0.05);
  const grandTotal = subtotal + gst;

  const handleProceedToSummary = () => {
    navigate("/kanchi-order-summary", {
      state: {
        cartItems,
        subtotal,
        gst,
        grandTotal,
      },
    });
  };

  return (
    <div className="basket-page">
      <h1 className="basket-title"> Basket</h1>

      <div className="basket-container">
        {cartItems.length === 0 ? (
          <p className="empty-text">Your basket is empty 🙏</p>
        ) : (
          cartItems.map((item) => (
            <div key={item.id} className="basket-item">
              <div className="item-left">
                <h3 className="item-name">{item.name}</h3>
                <p className="item-price">₹{item.price}</p>
              </div>

              <div className="item-right">
                <div className="qty-box">
                  <button onClick={() => decreaseQty(item.id)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => increaseQty(item.id)}>+</button>
                </div>

                <Trash2
                  size={18}
                  onClick={() => removeItem(item.id)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          ))
        )}
      </div>

      {cartItems.length > 0 && (
        <div className="basket-summary">
          <div className="summary-row">
            <span>Subtotal</span>
            <span>₹{subtotal}</span>
          </div>

          <div className="summary-row">
            <span>GST (5%)</span>
            <span>₹{gst}</span>
          </div>

          <div className="summary-row grand">
            <span>Grand Total</span>
            <span>₹{grandTotal}</span>
          </div>

          <div className="basket-buttons">
            <button
              className="secondary-btn"
              onClick={() => navigate("/kanchi-menu")}
            >
              Continue Offering
            </button>

            <GoldenButton onClick={handleProceedToSummary}>
              Place Order
            </GoldenButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default SacredBasket;